import HTTP from "../HTTP";
import Jsona from "jsona";
import transferHelper from "../helpers/transfers";
import paramsHelpers from "../helpers/params";
import transfersList from "@/store/modules/transfers/list";

const dataFormatter = new Jsona();

export default {
  async create(payload) {
    try {
      let transfer = await HTTP.normal.post(
        "/management/transfers/create",
        transferHelper.buildTransferRequestBody(payload)
      );
      return dataFormatter.deserialize(transfer.data);
    } catch (error) {
      throw error.response.data;
    }
  },
  async index(numberPage, fieldSort, textSearch) {
    try {
      let walletFilter = "&filter[channel_type]=Wallet";
      let search = textSearch ? `&filter[text_search]=${textSearch}` : "";
      let page = `&page[number]=${numberPage}`;
      let sort = "";
      let include =
        "include=payment_gateway_account.account.profile," +
        "channel.payment_gateway_account.account.profile";

      let results = await HTTP.normal.get(
        `/transfers?${include}${walletFilter}${search}${page}${sort}`
      );

      return {
        data: dataFormatter.deserialize(results.data),
        meta: results.data.meta
      };
    } catch (error) {
      throw "Ocorreu um erro ao listar as transferências";
    }
  },

  async getList() {
    try {
      let channelType = transfersList.state.channelType;
      let textSearch = transfersList.state.search;
      let number = transfersList.state.options.page;
      let size = transfersList.state.options.itemsPerPage;
      let professional = transfersList.state.professional;
      let fields = transfersList.state.options.sortBy;
      let desc = transfersList.state.options.sortDesc;

      if (!professional.account.payment_gateway_account) {
        return [];
      }

      let includes = [
        "payment_gateway_account.account.profile",
        "channel.payment_gateway_account.account.profile"
      ];

      let filters = [
        {
          name: "channel_type",
          value: channelType
        },
        {
          name: "text_search",
          value: textSearch
        }
      ];

      let dataParams = {
        includes,
        filters,
        sort: { fields, desc },
        pagination: { number, size }
      };

      let params = paramsHelpers.buildParams(dataParams);
      let url = `transfers${params}`;

      if (professional)
        url = `/payment-gateway-accounts/${professional.account.payment_gateway_account.id}/${url}`;

      let results = await HTTP.normal.get(url);

      return {
        data: dataFormatter.deserialize(results.data),
        totalItems: results.data.meta.record_count
      };
    } catch (e) {
      throw "Ocorreu um erro ao buscar o histórico de transferências!";
    }
  }
};



// WEBPACK FOOTER //
// ./src/API/modules/transfers.js